import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/login',
    name:"Login",
    component: () => import('@/views/login/index'),
    hidden: true,
    meta:{
      notNeedSpaceId:true,
      notMenus:true,
    }
  },
  {
    path: '/reloadPage',
    name:"ReloadPage",
    component: () => import('@/views/reloadPage/index'),
    hidden: true,
    meta:{
      notNeedSpaceId:true,
      notMenus:true,
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Dashboard',
    meta: {
      title: '工作空间',
      notMenus:true,
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard/index'),
        meta: {
          title: '工作空间',
          icon: 'el-icon-s-home',
          notNeedSpaceId:true,
        },
      },
    ]
  },

  {
    path: '/permission',
    component: Layout,
    name: 'Permission',
    meta: {
      title: '系统管理',
      icon: 'el-icon-user-solid',
    },
    children: [
      {
        path: 'user',
        component: () => import('@/views/permission/user'),
        name: 'User',
        meta: {
          title: '用户管理',
          notNeedSpaceId:true,
        }
      },
      {
        path: 'role',
        component: () => import('@/views/permission/role'),
        name: 'Role',
        meta: {
          title: '角色管理',
          notNeedSpaceId:true,
        }
      }
    ]
  },
  {
    path: '/risk',
    component: Layout,
    meta: {
      title: '工作模块',
      icon: 'el-icon-s-data',
    },
    children: [
      {
        name: 'roster',
        path: '/risk/roster',
        component: () => import('@/views/risk/roster'),
        meta: {
          path: '/risk/roster', title: '名单管理'
        }
      },
      {
        path: 'packages',
        component: () => import('@/views/risk/packages'),
        name: 'Packages',
        meta: {
          path:"/risk/packages",
          title: '规则包维护',
        }
      },
      {
        path: 'modules',
        component: () => import('@/views/risk/modules'),
        name: 'Modules',
        meta: {
          path:"/risk/modules",
          title: '组件资源',
        }
      },
      {
        path: 'rulesCan',
        component: () => import('@/views/risk/moduleSet/rulesCan/rulesCan'),
        name: 'rulesCan',
        hidden: true,
        meta: {
          path:"/risk/rulesCan",
          title: '规则集',
        }
      },
      {
        path: 'decisionTables',
        component: () => import('@/views/risk/moduleSet/decisionTables'),
        name: 'decisionTables',
        hidden: true,
        meta: {
          path:"/risk/decisionTables",
          title: '决策表',
        }
      },
      {
        path: 'score',
        component: () => import('@/views/risk/moduleSet/score'),
        name: 'score',
        hidden: true,
        meta: {
          path:"/risk/score",
          title: '评分卡',
        }
      },
      {
        path: 'decisionTree',
        component: () => import('@/views/risk/moduleSet/decisionTree/panel'),
        name: 'decisionTree',
        hidden: true,
        meta: {
          path:"/risk/decisionTree",
          title: '决策树',
        }
      },
      {
        path: 'fieldInput',
        component: () => import('@/views/risk/fieldInput'),
        name: 'FieldInput',
        meta: {
          path:"/risk/fieldInput",
          title: '输入字段',
        }
      },
      {
        path: 'fieldOutput',
        component: () => import('@/views/risk/fieldOutput'),
        name: 'FieldOutput',
        meta: {
          path:"/risk/fieldOutput",
          title: '输出字段',
        }
      },
      {
        path: 'onlineTest',
        component: () => import('@/views/risk/onlineTest'),
        name: 'OnlineTest',
        meta: {
          path:"/risk/onlineTest",
          title: '在线测试',
        }
      },
    ]
  },
  {
    path: '/journal',
    component: Layout,
    meta: {
      title: '日志监控',
      icon: 'el-icon-message-solid',
    },
    children: [
      {
        path: 'rulesReport',
        component: () => import('@/views/journal/rulesReport'),
        name: 'rulesReport',
        meta: {
          path: "/journal/rulesReport",
          title: '规则报表'
        }
      }, {
        path: 'packageUse',
        component: () => import('@/views/journal/packageUse'),
        name: 'packageUse',
        meta: {
          path:"/journal/packageUse",
          title: '规则调用日志'
        }
      }
    ]
  },
  {
    path: '/systemMonitor',
    component: Layout,
    meta: {
      title: '系统监控',
      icon: 'el-icon-s-help'
    },
    children: [
      {
        path: 'operationList',
        name: 'operationList',
        component: () => import('@/views/operationLog/operationList'),
        meta: {
          path: '/operationLog/operationList',
          title: '操作日志',
          notNeedSpaceId: true
        }
      }
    ]
  },
  {
    path: '/variable',
    component: Layout,
    meta: {
      title: '变量库管理',
      icon: 'el-icon-s-help',
      notNeedSpaceId: true,
    },
    children: [
      {
        path: 'variableList',
        name: 'variableList',
        component: () => import('@/views/variable/variableList'),
        meta: {
          title: '变量库',
          path: '/variable/variableList',
          notNeedSpaceId: true,
        },
      },
    ]
  },
  {
    path: '/template',
    component: Layout,
    meta: {
      title: '模板管理',
      icon: 'el-icon-s-help',
      notNeedSpaceId: true,
    },
    children: [
      {
        path: 'templateManagement',
        name: 'templateManagement',
        component: () => import('@/views/template/templateManagement'),
        meta: {
          title: '模板库',
          path: '/template/templateManagement',
          notNeedSpaceId: true,
        },
      },
      {
        path: 'packages',
        component: () => import('@/views/risk/packages'),
        name: 'Packages',
        hidden: true,
        meta: {
          path: "/risk/packages",
          title: '模板-规则包维护',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
      {
        path: 'modules',
        component: () => import('@/views/risk/modules'),
        name: 'Modules',
        hidden: true,
        meta: {
          path: "/risk/modules",
          title: '模板-组件资源',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
      {
        path: 'rulesCan',
        component: () => import('@/views/risk/moduleSet/rulesCan/rulesCan'),
        name: 'rulesCan',
        hidden: true,
        meta: {
          path: "/risk/rulesCan",
          title: '模板-规则集',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
      {
        path: 'decisionTables',
        component: () => import('@/views/risk/moduleSet/decisionTables'),
        name: 'decisionTables',
        hidden: true,
        meta: {
          path:"/risk/decisionTables",
          title: '模板-决策表',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
      {
        path: 'score',
        component: () => import('@/views/risk/moduleSet/score'),
        name: 'score',
        hidden: true,
        meta: {
          path:"/risk/score",
          title: '模板-评分卡',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
      {
        path: 'decisionTree',
        component: () => import('@/views/risk/moduleSet/decisionTree/panel'),
        name: 'decisionTree',
        hidden: true,
        meta: {
          path:"/risk/decisionTree",
          title: '模板-决策树',
          needControl: true,
          notNeedSpaceId: true,
          specialSpaceId: true,
        }
      },
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js